<template>
    <div
        :class="[
            'authentication-flow-panel',
            { 'center-vertically': centerVertically, 'sso-only-login': isSsoOnlyLoginMode },
        ]"
    >
        <div class="logo">
            <img title="logo" :srcset="infiniteLogoUrl" />
        </div>
        <form class="authentication-flow-form" @submit="handleFormSubmit">
            <h1 :class="['title', ' h1-dark', { 'with-back-button': withBackButton }]">
                <button v-if="withBackButton" class="back-icon" type="button" @click="handleBackButtonClick">
                    <elm-arrows-arrow-left-regular-icon size="20" />
                </button>
                {{ title }}
            </h1>

            <p v-if="description" class="paragraph-info instructions">{{ description }}</p>

            <slot></slot>
        </form>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Emit, Prop } from 'vue-property-decorator';

    import '@eloomi/icons/arrows/arrows-arrow-left-regular';

    import infiniteLogoUrl from '@/assets/img/infinite.svg';

    @Component({})
    export default class AuthenticationFlowPanel extends Vue {
        @Prop({ default: '', type: String }) public readonly title!: string;
        @Prop({ default: '', type: String }) public readonly description!: string;
        @Prop({ default: false, type: Boolean }) public readonly withBackButton!: boolean;
        @Prop({ default: false, type: Boolean }) public readonly isSsoOnlyLoginMode!: boolean;
        @Prop({ default: false, type: Boolean }) public readonly centerVertically!: boolean;

        public readonly infiniteLogoUrl = infiniteLogoUrl;

        @Emit('submit')
        public handleFormSubmit(e: Event) {
            e.preventDefault();
        }

        @Emit('back-button-click')
        public handleBackButtonClick() {
            return;
        }
    }
</script>

<style lang="less" scoped>
    .authentication-flow-panel {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        max-width: 391px;
        min-height: 573px;

        .md-viewport-and-smaller({
            min-height: auto;
        });

        &.center-vertically {
            justify-content: center;
        }

        &.sso-only-login {
            justify-content: center;
        }
    }

    .authentication-flow-form {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: @spacing-40 @spacing-24 @spacing-40 @spacing-24;
        background-color: @bright-color;
    }

    .logo {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 88px;
        height: 88px;
        margin-bottom: @spacing-24;

        .md-viewport-and-smaller({
            display: none;
        });

        img {
            width: 100%;
            height: 100%;
        }
    }

    .title {
        display: flex;
        align-items: center;
        justify-content: center;

        &.with-back-button {
            justify-content: flex-start;
        }
    }

    .back-icon {
        @invisible-padding: @spacing-8;

        display: inline-flex;
        margin: 0;
        margin: (-@invisible-padding) (-@invisible-padding);
        margin-right: @spacing-24 - @invisible-padding;
        padding: 0;
        padding: @invisible-padding;
        color: @color-info-40;
        background-color: transparent;
        border: none;
        cursor: pointer;
        .generic-transition(color);

        &:hover {
            color: @primary-color;
        }

        .md-viewport-and-smaller({
            display: none;
        });
    }

    .instructions {
        margin: 0;
        margin-top: @spacing-24;
    }
</style>
